import React from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline';

const faqs = [
  {
    question: "What is this platform?",
    answer: "Our platform enables users to create, test, and refine their own sports betting systems using historical data going back to 2018. Users can select custom criteria based on home and away team statistics to develop strategies that can be backtested to evaluate performance over time. We also monitor upcoming games to check for system matches. Not wanting to create your own systems? You can follow community published ones."
  },
  {
    question: "What sports / leagues are available?",
    answer: "Currently our platform covers MLB, NFL, and NBA. We are working on expanding our offerings to include more sports and leagues in the future!"
  },
  {
    question: "How do I create a betting system?",
    answer: "To create a betting system, navigate to the \"Systems\" page on our platform. Here, you can define your system by creating your own custom criteria, using stats, odds thresholds, and more. Once your criteria are set, you just select a bet and name your system then backtest it. Your systems can be kept private, or published to the community for others to follow. If you are unhappy with the results, edit your system criteria to refine it and when you are ready just click save!"
  },
  {
    question: "What kind of data is available for backtesting?",
    answer: "Our database currently includes team performance statistics, game outcomes, betting odds, and more, allowing for comprehensive analysis and testing of your betting systems."
  },
  {
    question: "How does the backtesting process work?",
    answer: "Once you have created a betting system, you can backtest it by clicking the \"Backtest\" button. The platform will then simulate how your system has performed historically. Every game is checked against your criteria and the results are displayed. Results include potential profits, win/loss ratios, and other key performance indicators."
  },
  {
    question: "Is there a limit to how many systems I can create or follow?",
    answer: "Nope. We believe in giving you the freedom to create and follow as many systems as you want."
  },
  {
    question: "Where can I get help if I have more questions, or have new feature ideas?",
    answer: "If you have further questions or want to recommend changes to the platform, please join our discord or direct message us on Twitter. We're here to help you make the most of our platform and ensure your betting strategies are as successful as possible."
  }
];

const FAQ = () => {
  return (
    <div className="bg-white dark:bg-brand-dark-900">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-40">
        <div className="mx-auto max-w-4xl">
          <h2 className="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
            Frequently asked questions
          </h2>
          <dl className="mt-10 space-y-6 divide-y divide-gray-200 dark:divide-white/10">
            {faqs.map((faq) => (
              <Disclosure as="div" key={faq.question} className="pt-6 first:pt-0">
                <dt>
                  <DisclosureButton className="group flex w-full items-start justify-between text-left text-gray-900 dark:text-white">
                    <span className="text-lg font-semibold">{faq.question}</span>
                    <span className="ml-6 flex h-7 items-center">
                      <PlusSmallIcon aria-hidden="true" className="size-6 text-brand-red-500 dark:text-brand-red-400 group-data-open:hidden" />
                      <MinusSmallIcon aria-hidden="true" className="size-6 text-brand-red-500 dark:text-brand-red-400 group-not-data-open:hidden" />
                    </span>
                  </DisclosureButton>
                </dt>
                <DisclosurePanel as="dd" className="mt-2 pr-12 pb-6">
                  <p className="text-base/7 text-gray-600 dark:text-gray-300">{faq.answer}</p>
                </DisclosurePanel>
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
};

export default FAQ;